/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/img-redundant-alt */
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { scrollToSection } from "../../utility/CommonFunctions";
import { useDispatch, useSelector } from "react-redux";
import { setActiveId } from "../../store/actions/UserActions";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [toggle, setToggle] = useState(false);
  const location = useLocation();
  const activeId = useSelector((state) => state.root.activeID);
  const dispatch = useDispatch();

  const handleToggle = () => {
    setToggle(!toggle);
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);



  return (
    <header className="fix_style fixed">
      {/* container start */}
      <div className="container">
        {/* navigation bar */}
        <nav className="navbar navbar-expand-lg">
          <Link className="navbar-brand" to={RoutesLink.home} onClick={() => dispatch(setActiveId(''))}>
            <img src={`${process.env.PUBLIC_URL}/assets/images/logo.png`} alt="image" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => handleToggle()}
          >
            <span className="navbar-toggler-icon">
              {/* <i class="icofont-navigation-menu ico_menu"></i> */}
              <div className={`toggle-wrap ${toggle ? "active" : ""}`}>
                <span className="toggle-bar" />
              </div>
            </span>
          </button>
          <div className={`collapse navbar-collapse ${toggle ? "show" : ""}`} id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link to={'/'} className={`nav-link ${activeId === "features" ? "active" : ""}`}
                  state={location.pathname !== "/" ? { id: 'features' } : null}
                  onClick={() => {
                    scrollToSection('features');
                    dispatch(setActiveId('features'));
                  }}
                >
                  Features
                </Link>
              </li>
              <li className="nav-item">
                <Link to={'/'} className={`nav-link ${activeId === "how_it_work" ? "active" : ""}`}
                  state={location?.pathname !== "/" ? { id: 'how_it_work' } : null}
                  onClick={() => {
                    scrollToSection('how_it_work');
                    dispatch(setActiveId('how_it_work'))
                  }}>
                  How it works
                </Link>
              </li>
              <li className="nav-item">
                <Link to={RoutesLink.blog}
                  className={`nav-link ${location?.pathname === "/blog" && activeId === "blog" ? "active" : ""}`}
                  onClick={() => {
                    dispatch(setActiveId('blog'));
                  }}>
                  Blog
                </Link>
              </li>
              <li className="nav-item">
                <Link to={RoutesLink.ContactUs}
                  className={`nav-link ${location?.pathname === RoutesLink.ContactUs && activeId === "contact-us" ? "active" : ""}`}
                  onClick={() => {
                    dispatch(setActiveId('contact-us'));
                  }}>
                  Contact Us
                </Link>
              </li>
              <li className="nav-item">
                <Link to={'/'} className={`nav-link ${activeId === "pricing" ? "active" : ""}`}
                  state={location?.pathname !== "/" ? { id: 'pricing' } : null}
                  onClick={() => {
                    scrollToSection('pricing');
                    dispatch(setActiveId('pricing'));
                  }}>
                  Pricing
                </Link>
              </li>
              <li className="nav-item">
                <a className="nav-link dark_btn" href="https://webapp.mybilty.com/login" target="_blank">
                  Sign up/Login
                </a>
              </li>
            </ul>
          </div>
        </nav>
        {/* navigation end */}
      </div>
      {/* container end */}
    </header >
  );
};
export default Header;
